const grFilterButtons = document.querySelectorAll('.gr-toggle-filter');
const grTargetElement = document.getElementById("gr-aside-menu");

grFilterButtons.forEach((button) => {
  button.addEventListener('click', function() {
    grTargetElement.classList.toggle('gr-active');
  });
});
